import React from 'react';
import { MapPin } from 'lucide-react';
import { companyInfo } from '../../mock';

const BOROUGHS = [
  { key: 'brooklyn', label: 'Brooklyn' },
  { key: 'queens', label: 'Queens' },
  { key: 'manhattan', label: 'Manhattan' },
];

export const ServiceAreas = () => (
  <section className="py-20 bg-gray-50" data-testid="service-areas-section">
    <div className="container mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-center max-w-3xl mx-auto mb-12">
        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Areas <span className="text-yellow-500">We Serve</span></h2>
        <div className="w-24 h-1 bg-yellow-400 mx-auto mb-4"></div>
        <p className="text-lg text-gray-600">Providing professional electrical services throughout the greater New York area.</p>
      </div>
      <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto">
        {BOROUGHS.map((borough) => (
          <div key={borough.key} className="space-y-4 p-6 rounded-xl border border-gray-200 hover:border-yellow-400 transition-all bg-white">
            <h3 className="text-xl font-bold text-gray-900 flex items-center space-x-2">
              <MapPin className="w-5 h-5 text-yellow-500" />
              <span>{borough.label}</span>
            </h3>
            <ul className="space-y-2">
              {companyInfo.serviceAreas[borough.key].map((area) => (
                <li key={area} className="text-gray-600 pl-7 hover:text-cyan-500 transition-colors">{area}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  </section>
);
